import { Modal as BootstrapModal } from 'bootstrap';

export class Modal {
  static danger({
    title = "",
    message = "",
    confirmText = "",
    cancelText = "",
    onConfirm = null,
    onCancel = null,
    size = 'sm'
  } = {}) {
    const existing = document.getElementById('generatedDangerModal');
    if (existing) existing.remove();

    const modalHTML = `
      <div class="modal fade" id="generatedDangerModal" tabindex="-1">
        <div class="modal-dialog modal-${size}" role="document">
          <div class="modal-content">
            <div class="modal-status bg-danger"></div>
            <div class="modal-body text-center py-4">
              <i class="ti ti-alert-triangle icon text-danger icon-lg"></i>
              <h3 class="mt-2">${title}</h3>
              <div class="text-secondary">${message}</div>
            </div>
            <div class="modal-footer">
              <div class="w-100">
                <div class="row">
                  ${cancelText !== "" ? `
                  <div class="col">
                    <a href="#" id="generatedDangerModalCancel" class="btn w-100" data-bs-dismiss="modal">${cancelText}</a>
                  </div>
                  ` : ""}
                  <div class="col">
                    <a href="#" id="generatedDangerModalConfirm" class="btn btn-danger w-100" data-bs-dismiss="modal">${confirmText}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>`;

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    const modalElement = document.getElementById('generatedDangerModal');
    const confirmButton = document.getElementById('generatedDangerModalConfirm');
    const cancelButton = document.getElementById('generatedDangerModalCancel');

    if (confirmButton && typeof onConfirm === 'function') {
      confirmButton.addEventListener('click', (e) => {
        e.preventDefault();
        onConfirm();
      });
    }

    if (cancelButton && typeof onCancel === 'function') {
      cancelButton.addEventListener('click', (e) => {
        e.preventDefault();
        onCancel();
      });
    }

    const bsModal = new BootstrapModal(modalElement, { backdrop: 'static' });
    bsModal.show();
  }
}
